import React from 'react';
import tw, { styled } from 'twin.macro';

const LoadingContainer = styled.div`
  ${tw`flex items-center justify-center p-8`}
`;

const Spinner = styled.div`
  ${tw`animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500`}
`;

const LoadingText = styled.p`
  ${tw`ml-3 text-gray-600`}
`;

const LoadingSpinner = ({ text = "Loading...", size = "default" }) => {
  const spinnerSize = size === "small" ? "h-4 w-4" : size === "large" ? "h-12 w-12" : "h-8 w-8";
  
  return (
    <LoadingContainer>
      <Spinner className={spinnerSize} />
      {text && <LoadingText>{text}</LoadingText>}
    </LoadingContainer>
  );
};

export default LoadingSpinner;
